import axios from "axios";

// 创建 Axios 实例
const service = axios.create({
  baseURL: "https://yinheapi.yinheshujie.com/prod-api",
  // baseURL: "http://192.168.2.22:9001",
  timeout: 20000
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      return Promise.reject(new Error(res.msg || "Error"));
    }

    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
